
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/prices-and-payment/[[...slug]]",
      function () {
        return require("private-next-pages/prices-and-payment/[[...slug]].page.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/prices-and-payment/[[...slug]]"])
      });
    }
  